import { render } from "./Mover.vue?vue&type=template&id=1949b2a3&scoped=true"
import script from "./Mover.vue?vue&type=script&lang=js"
export * from "./Mover.vue?vue&type=script&lang=js"

import "./Mover.vue?vue&type=style&index=0&id=1949b2a3&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1949b2a3"]])

export default __exports__